import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgBotOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#4384F5",
			fillRule: "nonzero",
			d: "M13.833 13.833H2.167v-10h11.666v10zm0-11.666H2.167C1.25 2.167.5 2.917.5 3.833v10c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667v-10c0-.916-.75-1.666-1.667-1.666z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#4384F5",
			fillRule: "nonzero",
			d: "M10.917 8a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zM5.083 8a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm-.416 2.5h6.666v1.667H4.667V10.5zm-.834-6.667V.5H5.5v3.333H3.833zm6.667 0V.5h1.667v3.333H10.5z"
		})]
	})
});
export default SvgBotOutline;
